// Define Types
interface Protocol {
    loraWan?: object;
    mqtt?: {
      url: string;
      ca: string;
      clientCert: string;
      clientKey: string;
      port: number;
      clientId: string;
      qos: number;
    };
  }
  
  interface ModemType {
    cell?: {
      model: string;
      apn: string;
      imei: number;
      iccid: number;
      fwVer: string;
    };
    loraWan?: object;
    antenna?: number;
  }
  
  interface Curr420Config {
    index: number;
    enable: boolean;
    powerOnTime: number;
    sensorMin: number;
    sensorMax: number;
    unit: number;
    samplingRate: number;
    reportingRate: number;
    convert: boolean;
  }
  
  interface ModbusRequest {
    index: number;
    devAddress: number;
    startReg: number;
    count: number;
    function: number;
    nextRequestInterval: number;
    requestTimeout: number;
  }
  
  interface SerialConfig {
    index: number;
    enable: boolean;
    phyMode: number;
    baud: number;
    dataWidth: number;
    parity: number;
    stopbit: number;
    termination: boolean;
    samplingRate: number;
    reportingRate: number;
    powerType: number;
    sampleDelay: number;
    interval: number;
    retry: number;
    transparentMode: boolean;
    numberOfRequests: number;
    protocolCmd: {
      modbus: {
        request: ModbusRequest[];
      };
    };
  }
  
  interface DeviceConfig {
    deviceId: string;
    deviceType: number;
    hwVer: string;
    swVer: string;
    claimId: string;
    protocol: Protocol;
    modemType: ModemType;
    curr420Config: Curr420Config[];
    serial: SerialConfig[];
  }
  
  export const editConfig: DeviceConfig = {
    deviceId: "0xAABBCCDD",
    deviceType: 1,
    hwVer: "0.4",
    swVer: "0.0",
    claimId: "UC",
    protocol: {
      loraWan: {},
      mqtt: {
        url: "aws.amazon.com",
        ca: "aws.ca",
        clientCert: "aws_clinet.ca",
        clientKey: "aws.clientKey",
        port: 742,
        clientId: "AWS_CLIENT",
        qos: 1,
      },
    },
    modemType: {
      cell: {
        model: "EC25",
        apn: "cell_apn",
        imei: 99999999999999999999,
        iccid: 88888888888888888888,
        fwVer: "1.5",
      },
      loraWan: {},
      antenna: 1,
    },
    curr420Config: [
      {
        index: 1,
        enable: false,
        powerOnTime: 100,
        sensorMin: 0,
        sensorMax: 1023,
        unit: 0,
        samplingRate: 1,
        reportingRate: 15,
        convert: false,
      },
      {
        index: 2,
        enable: false,
        powerOnTime: 200,
        sensorMin: 5,
        sensorMax: 1023,
        unit: 0,
        samplingRate: 1,
        reportingRate: 4,
        convert: false,
      },
    ],
    serial: [
      {
        index: 0,
        enable: true,
        phyMode: 0,
        baud: 10,
        dataWidth: 8,
        parity: 0,
        stopbit: 1,
        termination: false,
        samplingRate: 1,
        reportingRate: 15,
        powerType: 1,
        sampleDelay: 2000,
        interval: 5000,
        retry: 3,
        transparentMode: false,
        numberOfRequests: 2,
        protocolCmd: {
          modbus: {
            request: [
              {
                index: 1,
                devAddress: 1,
                startReg: 16,
                count: 8,
                function: 4,
                nextRequestInterval: 1000,
                requestTimeout: 5000,
              },
              {
                index: 2,
                devAddress: 1,
                startReg: 35,
                count: 8,
                function: 4,
                nextRequestInterval: 1000,
                requestTimeout: 5000,
              },
            ],
          },
        },
      },
    ],
  };